export const environment = {
  production: false,
  USERDATA_KEY: 'userdataf649fc9artyg5f5914322w',
  USER_ID_KEY: 'useridf649tyyuudfc9a5f5522wow',
  TOKENT_KEY: 'tokenf649fwadfgggc9a5f5khahg5',
  apiUrl: 'https://crm-api-dev.goldeneagle.app/api/v1/',
};